import React, {Component} from 'react';
import {browserHistory, Link} from 'react-router';

import Button from '../../components/Button';
import {firebaseConnect, helpers} from "react-redux-firebase";
const { isLoaded, isEmpty, pathToJS, dataToJS } = helpers;
import {connect} from "react-redux";

export class TrialExpired extends Component {
    handleLogout(event) {
        event.preventDefault();
        this.props.firebase.logout();
        browserHistory.replace("/");
    }

    render() {
        let firebase = this.props.firebase;

        if(!this.props.profile.disabled && this.props.profile.trial){
            firebase.set(`/users/${this.props.profile.id}/disabled`, true);
        }

        return (
            <div className="main-content-area">
                <div className="page-content">
                    <div className="flex-center-container">
                        <div className="content-area-notification rich-text">
                            <h1>Your trial has expired</h1>
                            <p className="lg light-text-color">Click link below to contact us about pricing or extending
                                your trial.</p>
                            <a href="mailto:info@colvardlearning.com" className="button secondary">Contact Us</a>
                            <Button
                                buttonClass="secondary"
                                label='Log out'
                                onClick={this.handleLogout.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        setUserData : (profile) => { dispatch(setUserData(profile)); },
        addNotification : (key, message) => { dispatch(addNotification(key, message)); }
    };
};

const fbWrappedComponent = firebaseConnect()(TrialExpired);

export default connect(
    ({ firebase }) => ({
        profile: pathToJS(firebase, 'profile'),
        authError: pathToJS(firebase, 'authError'),
        auth: pathToJS(firebase, 'auth')
    }),
    null
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/containers/TrialExpired/TrialExpired.js